var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container service-panel" },
    [
      _vm.isLoading ? _c("loading-overlay") : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage && !_vm.isLoading
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 col-12" }, [
              _c("div", { staticClass: "fade-in-out alert alert-error" }, [
                _c("div", [_vm._v(_vm._s(_vm.errorMessage))])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.platformCategory
        ? _c(
            "div",
            [
              _vm.platformCategory == "HR"
                ? _c("browse-standard-service", {
                    key: _vm.componentKey,
                    attrs: {
                      "platform-category": _vm.platformCategory,
                      "platform-category-name": _vm.platformCategoryName,
                      "category-id": _vm.categoryId
                        ? _vm.categoryId
                        : _vm.serviceId
                    }
                  })
                : _c("browse-service-taxonomy-service", {
                    attrs: {
                      "platform-category": _vm.platformCategory,
                      "platform-category-name": _vm.platformCategoryName,
                      "category-id": _vm.categoryId,
                      "service-id": _vm.serviceId
                    }
                  })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ef7af0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef7af0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-browser/BrowseService.vue
// module id = null
// module chunks = 